// extracted by css-extract-rspack-plugin
export default {"buttonWrap":"CsvDownloadModal__buttonWrap--fhUQI"};